module.exports = {
  development: {
    siteUrl: "http://localhost:3001",
    api: {
      // baseUrl: "https://localhost:44320",
      baseUrl: "https://dwebsrv03.lbcapps.com/corp-dash-api",
      lbcOAkey: "3cf4f9cb1bb34f60a03f1a4b0f74208e",
      lbccommonrefv2Url:
        "https://lbcapigateway.lbcapps.com/lbccommonreference/v2/v2",
      lbccommonrefv2LbcOAkey: "e8432716e5d3424bb2322a43fd4e470a",
      trackingUrl: "https://lbcapigateway.lbcapps.com/lbctrackingapi2/v2",
      trackingLBCOAkey: "d318501d4a18473f8e819c21048b63c9",
    },
    supportCenterEmailCorp: "mbparreno@lbcexpress.com",
    supportCenterEmailRetail: "Sales_Support@lbcexpress.com",
  },
  uat: {
    siteUrl: "https://lbccorporate-staging.lbcexpress.com",
    api: {
      baseUrl: "https://lbcapigateway.lbcapps.com/lbccorporateapi-staging/v1",
      lbcOAkey: process.env.REACT_APP_LBC_OAKEY,
      lbccommonrefv2Url:
        "https://lbcapigateway.lbcapps.com/lbccommonreference/v2/v2",
      lbccommonrefv2LbcOAkey: "e8432716e5d3424bb2322a43fd4e470a",
      trackingUrl: "https://lbcapigateway.lbcapps.com/lbctrackingapi2/v2",
      trackingLBCOAkey: "d318501d4a18473f8e819c21048b63c9",
    },
    supportCenterEmailCorp: "mbparreno@lbcexpress.com",
    supportCenterEmailRetail: "Sales_Support@lbcexpress.com",
  },
  production: {
    siteUrl: "https://corporate.lbcexpress.com",
    api: {
      baseUrl: "https://lbcapigateway.lbcapps.com/lbccorporateapi/v1",
      lbcOAkey: process.env.REACT_APP_LBC_OAKEY,
      lbccommonrefv2Url:
        "https://lbcapigateway.lbcapps.com/lbccommonreference/v2/v2",
      lbccommonrefv2LbcOAkey: process.env.REACT_APP_LBC_COMMON_REF_V2_OAKEY,
      trackingUrl: "https://lbcapigateway.lbcapps.com/lbctrackingapi2/v2",
      trackingLBCOAkey: process.env.REACT_APP_TRACKING_LBC_OAKEY,
    },
    supportCenterEmailCorp: "mbparreno@lbcexpress.com",
    supportCenterEmailRetail: "Sales_Support@lbcexpress.com",
  },
};
